import Page from "~/pages/Page";


export default class Generic extends Page {
    constructor() {
        super("generic", "Generic Page");
    }
    pageStart(): Promise<void> {
        return Promise.resolve();
    }
}